"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AuthPayMonthly_1 = __importDefault(require("./Cards/AuthPayMonthly"));
var NonAuthPayMonthly_1 = __importDefault(require("./Cards/NonAuthPayMonthly"));
var NonAuthPayOnce_1 = __importDefault(require("./Cards/NonAuthPayOnce"));
var TileDataContext_1 = require("../TileDataContext");
function PriceDetailsPanel() {
    var hasSoftPull = (0, TileDataContext_1.useTileDataContext)().financeInfo.hasSoftPull;
    return hasSoftPull ? (react_1.default.createElement("div", { className: "pb-20", "data-qa": "softpull-card" },
        react_1.default.createElement(AuthPayMonthly_1.default, null))) : (react_1.default.createElement("div", { className: "flex flex-col items-center gap-16 pb-24", "data-qa": "non-softpull-card" },
        react_1.default.createElement(NonAuthPayMonthly_1.default, null),
        react_1.default.createElement(NonAuthPayOnce_1.default, null)));
}
exports.default = PriceDetailsPanel;
//# sourceMappingURL=PriceDetailsPanel.js.map